/**
 * Engage embed typography (TSAI uiController.js px ladder).
 *
 * Use px utilities only — Tailwind `text-base` / `text-sm` are rem-based and
 * resolve against the host page `<html>` font-size. WordPress themes often set
 * `html { font-size: 62.5% }` (10px), which shrinks rem-based widget chrome.
 */
export const WIDGET_TEXT_PRIMARY = 'text-[16px]';
export const WIDGET_TEXT_SECONDARY = 'text-[14px]';
export const WIDGET_TEXT_CONTROL = 'text-[13px]';
export const WIDGET_TEXT_MICRO = 'text-[10px]';
/** TSAI `.branding` footer (uiController.js). */
export const WIDGET_TEXT_BRANDING = 'text-[12px]';
export const WIDGET_LEADING_PRIMARY = 'leading-[1.45]';
